module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "region-box pull-left"
  }, [_c('button', {
    staticClass: "back pull-left"
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "margin-top": "3px"
    },
    attrs: {
      "src": require("../../images/corner-up-left@2x.png")
    },
    on: {
      "click": function($event) {
        return _vm.jump('/ib_v2/ibSetting')
      }
    }
  })]), _vm._v(" "), (_vm.apiChangeable && _vm.$route.path.split('/')[2] !== 'ibCommissionSetting') ? _c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.area), function(item) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.actArea
      },
      on: {
        "click": function($event) {
          return _vm.areaGroupSwitchFn(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }), 0) : _c('div', {
    staticClass: "btn-group pull-left"
  }, _vm._l((_vm.area), function(item, key) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': item == _vm.actArea
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('btn-group', {
    staticClass: "primary-box pull-right"
  }, [_c('btn', {
    class: {
      'active': (_vm.activePrimary == '/ibSetting' || _vm.activePrimary == '/ibCommissionSetting')
    },
    on: {
      "click": function($event) {
        return _vm.jump('/ib_v2/ibSetting')
      }
    }
  }, [_vm._v("\n             " + _vm._s(_vm.ibPrimaryLan.commissionSetting) + "\n          ")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Result') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    },
    on: {
      "click": _vm.checkCpaFn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ibPrimaryLan.ibResult.title))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.ibPrimaryLan.ibResult_v2.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [(item.link !== '/ib_v2/CPACommissionResult' || _vm.checkCpa) ? _c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('Dropdown', {
    staticClass: "pull-left seekDropdown",
    staticStyle: {
      "margin-left": "-1px"
    },
    attrs: {
      "menu-right": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      'active': _vm.activePrimary.indexOf('Report') != -1
    },
    attrs: {
      "data-role": "trigger",
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ibPrimaryLan.ibReport.title))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._l((_vm.ibPrimaryLan.ibReport_v2.list), function(item, index) {
    return _c('template', {
      slot: "dropdown"
    }, [_c('li', {
      class: {
        'active': _vm.activePrimary == item.link
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "curArea": _vm.curArea,
      "status": _vm.status
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec6d1722","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/ibPrimary.vue
// module id = 1146
// module chunks = 1